<template>
  <div id="app">
    <LoadingScreen v-if="whitelabel === 'undefined'" />
    <div v-else>
      <Sidebar />
      <Main />
      <Footer />
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/Sidebar.vue";
import Main from "./components/Main.vue";
import Footer from "./components/Footer.vue";
import LoadingScreen from "./components/LoadingScreen.vue";
import { getCurrentInstance, ref, onMounted } from "vue";

// eslint-disable-next-line no-unused-vars
const loadResources = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, 2000);
  });
};

export default {
  name: "App",
  components: {
    Sidebar,
    Main,
    Footer,
    LoadingScreen,
  },
   setup() {
    const whitelabel = ref(null);
    const { appContext } = getCurrentInstance();

    onMounted(() => {
      whitelabel.value = appContext.config.globalProperties.whitelabel;
    });

    return {
      whitelabel,
    };
  },
};
</script>

<style>
#app {
  font-family: var(--font-poppins);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

:root {
  --color-default: #752de6;
  --purple-hover: #6926d4e5;
  --black: #333333;
  --background-code: #1c1d21;
  --green-code: #65b042;
  --font-poppins: "Calibri", sans-serif;
  --font-code: "Source Code Pro", monospace;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

table th {
  background-color: #f5f5f5;
  font-weight: bold;
}

table td code {
  background-color: #f5f5f5;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 12px;
  color: #333;
}

table th {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  text-align: center;
  padding: 8px;
}

table td {
  border: 1px solid #e0e0e0;
  text-align: center;
  padding: 8px;
}

table th:nth-child(1) {
  width: 20%;
}

table th:nth-child(2) {
  width: 20%;
}

table td:nth-child(3) {
  width: 60%;
  text-align: left;
}

h1 {
  font-size: 30px;
  font-weight: bold;
  color: #2c3e50;
}

h2 {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
}

p {
  color: #808080;
  font-size: 14px;
}

.type {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 15px;
  display: inline-block;
  margin: 0 0 5px 0;
  padding: 5px 10px;
  border-radius: 3px;
  text-transform: uppercase;
  color: #ffffff;
}

.post {
  background-color: #8a2be2;
}

.get {
  background-color: #28a745;
}

.put {
  background-color: #e5c500;
}

.delete {
  background-color: #ed0039;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  max-width: 100%;
  margin: 0;
  height: auto;
}

code {
  max-width: 100%;
  display: block;
  border-radius: 8px;
  padding: 1rem !important;
}

.app-json {
  color: #c7254e;
  background-color: #f9f2f4;
  font-size: 1rem;
  padding: 2px 4px;
}

.url {
  font-family: monospace, monospace;
  width: 97.8%;
  background-color: var(--background-code);
  color: white;
  padding: 1rem;
  border-radius: 8px;
  word-break: break-all;
  display: inline-block;
}

.code-toggle {
  margin: 3rem 0 0 0;
}

button {
  font-size: 18px;
  margin-right: 5px;
  border: none;
  padding: 10px;
  cursor: pointer;
  border-radius: 3px;
  font-weight: bold;
}

button.active {
  background-color: var(--black);
  color: white;
}

.btn02 {
  font-weight: 400;
}

a {
  text-decoration: none;
}

.section-item {
  padding: 3rem 0;
  text-align: start;
  border-bottom: 3px solid rgba(107, 35, 220, 0.2);
}
</style>
